/**
 * toastManager — Gestisce stack di notifiche toast.
 *
 * Ascolta eventi custom su window per mostrare toast automaticamente.
 * Auto-dismiss dopo 5 secondi con animazione leave.
 *
 * Uso nel template:
 *   <div x-data="toastManager" class="ik-toast-container">
 *       <template x-for="toast in toasts" :key="toast.id">
 *           ...
 *       </template>
 *   </div>
 */
export function registerToastManager(Alpine) {
    Alpine.data('toastManager', () => ({
        toasts: [],
        _nextId: 1,

        init() {
            // Registrazione avvenuta con successo (flag da redirect post-register)
            if (sessionStorage.getItem('ik_register_success') === '1') {
                sessionStorage.removeItem('ik_register_success');
                this.add('success', 'Registrazione completata! Benvenuto.');
            }

            // Wishlist: aggiunto/rimosso
            window.addEventListener('wishlist-item-added', () => {
                this.add('success', 'Corso aggiunto alla wishlist');
            });
            window.addEventListener('wishlist-item-removed', () => {
                this.add('info', 'Corso rimosso dalla wishlist');
            });

            // Carrello: aggiunto con coupon o convenzione
            window.addEventListener('cart-item-added', (e) => {
                const { coupon, agreement } = e.detail || {};
                if (coupon) {
                    this.add('success', 'Corso aggiunto con codice coupon ' + coupon);
                } else if (agreement) {
                    this.add('success', 'Corso aggiunto con convenzione ' + agreement);
                }
            });

            // Carrello: errore aggiunta
            window.addEventListener('cart-item-error', (e) => {
                const msg = e.detail?.message || 'Si è verificato un errore';
                this.add('error', msg);
            });

            // Login OTP avvenuto con successo (senza redirect)
            window.addEventListener('otp-login-success', () => {
                this.add('success', 'Accesso effettuato con successo.');
            });

            // Generico: qualsiasi componente può mostrare un toast
            window.addEventListener('show-toast', (e) => {
                const { type, message } = e.detail || {};
                if (type && message) this.add(type, message);
            });
        },

        /**
         * Aggiunge un toast alla stack.
         * @param {'success'|'error'|'warning'|'info'} type
         * @param {string} message
         */
        add(type, message) {
            const iconMap = { success: 'check-circle', error: 'alert-circle', warning: 'alert-circle', info: 'alert-circle' };
            const id = this._nextId++;
            this.toasts.push({ id, type, message, leaving: false, icon: iconMap[type] || 'alert-circle' });

            // Auto-dismiss dopo 5s
            setTimeout(() => this.dismiss(id), 5000);
        },

        /**
         * Rimuove un toast con animazione leave.
         */
        dismiss(id) {
            const toast = this.toasts.find(t => t.id === id);
            if (!toast || toast.leaving) return;

            toast.leaving = true;

            // Rimuovi dopo animazione (300ms)
            setTimeout(() => {
                this.toasts = this.toasts.filter(t => t.id !== id);
            }, 300);
        },
    }));
}
